import type { PowerPerformanceForms } from '../../../../types/mutual-fund-detail.types'
import { FundCardLayout } from './FundCardLayout'

type ReinvestFundCardProps = {
  fundLogo: string
  fundTitle: string
  fundNature: string
  fundCategory: string
  powerRank: number
  powerRating?: `${PowerPerformanceForms}`
  isRegular?: boolean
  onClick?: () => void
}

export function ReinvestFundCard({
  fundLogo,
  fundTitle,
  fundNature,
  fundCategory,
  powerRank,
  powerRating,
  isRegular,
  onClick
}: ReinvestFundCardProps) {
  return (
    <FundCardLayout
      fundLogo={fundLogo}
      fundTitle={fundTitle}
      fundNature={fundNature}
      fundCategory={fundCategory}
      trailingContent={<ChevronRight />}
      powerRank={powerRank}
      powerRating={powerRating}
      isRegular={isRegular}
      onClick={onClick}
    />
  )
}

export function ChevronRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath="url(#clip0_71014_461277)">
        <path d="M10.4934 5.74398L4.75337 0.283979C4.6528 0.188377 4.53439 0.113518 4.40489 0.0636785C4.27539 0.0138385 4.13735 -0.0100072 3.99864 -0.00649718C3.85992 -0.00298713 3.72326 0.02781 3.59645 0.0841357C3.46964 0.140461 3.35517 0.221213 3.25957 0.321779C3.06649 0.524882 2.962 0.796366 2.96909 1.07651C2.97618 1.35665 3.09426 1.6225 3.29737 1.81558L8.49417 6.75058C8.52865 6.78316 8.55613 6.82244 8.57491 6.86601C8.59368 6.90959 8.60337 6.95653 8.60337 7.00398C8.60337 7.05143 8.59368 7.09837 8.57491 7.14194C8.55613 7.18552 8.52865 7.2248 8.49417 7.25738L3.29737 12.1924C3.09538 12.3842 2.97784 12.6483 2.97062 12.9268C2.9634 13.2052 3.06709 13.4751 3.25887 13.6771C3.45064 13.8791 3.71481 13.9966 3.99324 14.0038C4.27168 14.011 4.54158 13.9074 4.74357 13.7156L10.5074 8.24158C10.6714 8.07718 10.8012 7.88192 10.8893 7.66708C10.9774 7.45224 11.0221 7.22207 11.0208 6.98986C11.0195 6.75765 10.9723 6.528 10.8817 6.31416C10.7912 6.10032 10.6592 5.90653 10.4934 5.74398Z" fill="#8E9393" />
      </g>
      <defs>
        <clipPath id="clip0_71014_461277">
          <rect width="14" height="14" fill="currentColor" transform="translate(6.11959e-07 14) rotate(-90)" />
        </clipPath>
      </defs>
    </svg>
  )
}
